import React from "react";
import "./CaShreyashPrivacy.css";

export default function CaShreyashPrivacy() {
    return (
        <div className="privacy-container">
            <div className="privacy-card">

                <h1 className="privacy-title">CA Shreyash Privacy Policy</h1>
                <p className="privacy-updated">Last Updated: November 10, 2025</p>

                <div className="privacy-content">

                    <p>
                        This privacy policy applies to the CA Shreyash app (the "Application")
                        created by ITPL ("Service Provider") as a free service. This service is
                        provided strictly “AS IS”.
                    </p>

                    <h2>Information Collection and Use</h2>
                    <p>The Application may collect information such as:</p>
                    <ul>
                        <li>Your device's IP address</li>
                        <li>Pages visited, and visit time/date</li>
                        <li>Time spent inside the Application</li>
                        <li>Your device operating system</li>
                    </ul>

                    <p>
                        The Application does <strong>not</strong> collect your exact device location.
                    </p>

                    <p>
                        The Service Provider may use your information to send important updates,
                        notices, and promotional messages.
                    </p>

                    <p>
                        For a better experience, you may be asked for personal information such as
                        <strong> sparkcomputer555@gmail.com</strong>.
                    </p>

                    <h2>Third Party Access</h2>
                    <p>
                        Aggregated, anonymized data may be shared with external services only to
                        improve the Application.
                    </p>
                    <p>Third-party services used include:</p>
                    <ul>
                        <li>Google Play Services</li>
                        <li>Google Analytics for Firebase</li>
                        <li>Firebase Crashlytics</li>
                    </ul>

                    <h2>Disclosure of Information</h2>
                    <p>The Service Provider may disclose information:</p>
                    <ul>
                        <li>To comply with legal requirements</li>
                        <li>To protect rights or safety</li>
                        <li>To investigate fraud or respond to authorities</li>
                        <li>To trusted partners under strict confidentiality</li>
                    </ul>

                    <h2>Opt-Out Rights</h2>
                    <p>
                        You can stop all data collection by uninstalling the Application using standard
                        uninstall options on your device.
                    </p>

                    <h2>Data Retention Policy</h2>
                    <p>
                        User data is retained while you use the Application and for a reasonable time
                        afterward. For deletion, email:
                        <strong> sparkcomputer555@gmail.com</strong>.
                    </p>

                    <h2>Children</h2>
                    <p>
                        The Application does not knowingly collect data from children under 13. If such
                        data is found, it is deleted immediately.
                    </p>

                    <h2>Security</h2>
                    <p>
                        The Service Provider uses electronic, physical, and procedural safeguards to
                        protect collected information.
                    </p>

                    <h2>Changes to This Policy</h2>
                    <p>
                        This Privacy Policy may be updated periodically. Continued use means acceptance
                        of any changes.
                    </p>

                    <h2>Your Consent</h2>
                    <p>
                        By using the Application, you consent to the processing of your information as
                        outlined in this Privacy Policy.
                    </p>

                    <h2>Contact Us</h2>
                    <p>
                        For questions about this Privacy Policy, contact: <br />
                        <strong>sparkcomputer555@gmail.com</strong>
                    </p>
                </div>

            </div>
        </div>
    );
}
